module.exports = __webpack_public_path__ + "img/roomcard_level2.95ad18c7.png";